import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* Material */
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';

/* Translation */
import { TranslateModule } from '@ngx-translate/core';

/* LiveDOK modules */
import { SharedModule } from '../shared/shared.module';
import { DocumentsModule } from '../documents/documents.module';

/* local components */
import { WebdokuPageComponent } from './webdoku/webdoku-page.component';
import { NoWebdokuPageComponent } from './no-webdoku/no-webdoku-page.component';
import { WebDokuListItemComponent, WebDokuListViewComponent } from './components';

@NgModule({
  declarations: [WebdokuPageComponent, NoWebdokuPageComponent, WebDokuListItemComponent, WebDokuListViewComponent],
  exports: [WebdokuPageComponent, NoWebdokuPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatIconModule,
    MatListModule,
    MatTableModule,
    TranslateModule,
    DocumentsModule,
    MatTabsModule,
    MatToolbarModule,
  ],
})
export class WebDokuModule {}
